import * as Yup from 'yup'

export interface IHighlightSchema {
    name: string
    description: string
    url: string
    publicationDate: Date
}
const highlightSchema: Yup.SchemaOf<IHighlightSchema> = Yup.object().shape({
    name: Yup.string().required('Preencha o campo título.').max(50, 'Máx 50 caracteres'),
    description: Yup.string().required('Preencha o campo descrição.').max(50, 'Máx 50 caracteres'),
    url: Yup.string().url('Preencha o campo com uma URL válida').required('Preencha o campo url.').max(255, 'Máx 255 caracteres'),
    publicationDate: Yup.date().required('Preencha o campo data'),
})

export default highlightSchema
